
const { document } = require('window');

const $ = require('jquery');

const cuid = require('cuid');

const getTargetByAttr = require('./get-target-by-attr.js');


/*
 * This thing allows labels to have relative `for` selectors like `<label for="$next">`
 */


$(document).on('click.rgs-bs.label-for.data-api', 'label[for^="$"]', function () {
	const $this = $(this);
	const $target = getTargetByAttr($this, 'for');

	let id;
	if ($target.attr('id')) {
		id = $target.attr('id');
	} else {
		id = cuid();
		$target.attr('id', id);
	}

	$this.attr('for', id);
});

